module.exports = __webpack_public_path__ + "static/28-ca1d3fb53e882919917094dd4021b036.jpg";